import { SstCommentFront, SstFront } from '@entities/Sst/type';

/**
 * Puts a comment at the top of an SST, unless that comment is already there.
 *
 * Two writers race to add a comment the viewer just posted: the websocket event,
 * emitted the moment it is stored, and the response of the POST that created it.
 * Either can arrive first, so both come through here and the second one is a
 * no-op. Without the guard the author saw their own comment twice, from whichever
 * arrived second until the next refetch replaced the list with the server's.
 */
export const withComment = (sst: SstFront, comment: SstCommentFront): SstFront =>
  sst.comments.some(existing => existing.id === comment.id) ? sst : { ...sst, comments: [comment, ...sst.comments] };
